import { render, staticRenderFns } from "./IsGranted.vue?vue&type=template&id=49c1a5fe&scoped=true&"
import script from "./IsGranted.vue?vue&type=script&lang=js&"
export * from "./IsGranted.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49c1a5fe",
  null
  
)

export default component.exports